module.exports = __webpack_public_path__ + "img/item3.9a9a0e7d.png";